import changelogRaw from '/CHANGELOG.md?raw'

export type ChangelogVersion = {
  version: string
  date: string
  content: string
}

const parseVersions = (raw: string): ChangelogVersion[] => {
  const versions: ChangelogVersion[] = []
  const blocks = raw.split(/^## v/m).slice(1)

  for (const block of blocks) {
    const firstLine = block.split('\n')[0]
    const match = firstLine.match(/^([\d.]+)\s*\((\d{4}-\d{2}-\d{2})\)/)
    if (!match) continue

    const content = block
      .split('\n')
      .slice(1)
      .join('\n')
      .trim()

    versions.push({
      version: match[1],
      date: match[2],
      content,
    })
  }

  return versions
}

export const versions = parseVersions(changelogRaw)

export const getFullChangelog = (): string => changelogRaw

export const getLatestVersion = (): ChangelogVersion | undefined => versions[0]
